import palette from '@lib/core/src/theme/palette';
import { Stack, styled } from '@mui/material';

export const TimingCard = styled(Stack, { shouldForwardProp: prop => prop !== 'isActive' })<{
  isActive: boolean;
}>(({ isActive }) => ({
  borderRadius: '8px',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  padding: '16px 12px',
  backgroundColor: palette.white,
  color: isActive ? palette.black : palette.grey[500],
  border: `${isActive ? 1.5 : 1}px solid ${isActive ? palette.grey[500] : palette.grey[1200]}`,
  '&:hover': {
    background: palette.grey[800],
    cursor: 'pointer'
  }
}));
